module.exports = "<div>\r\n\r\n    <canvas id=\"canvas-box\"></canvas>\r\n\r\n</div>";